









































































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import HsaAccountCard from "@/employee/components/landing-pages/accountSummaryDashboard/HsaAccountCard.vue";
import NotionalAccountCard from "@/employee/components/landing-pages/accountSummaryDashboard/NotionalAccountCard.vue";
import WidgetGridContainer from "@/shared/components/ui/WidgetGridContainer.vue";
import {
  CommunicationDashboard,
  FetchState,
  UserEventKey,
  UserEventType
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";
import {
  getRoutePath,
  openUrl
} from "@/shared/urlHelper";
import { useUserStore } from "@/shared/store/user";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useCommunicationStore } from "@/shared/store/communication";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import * as RouteNames from "@/employee/route-names";
import ActionNeededExpensesWidget from "@/employee/components/hsabExpenses/ActionNeededExpensesWidget.vue";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import AddMfa from "@/employee/components/onboarding/AddMfa.vue";

@Component({
  components: {
    AddMfa,
    ActionNeededExpensesWidget,
    GenericLoadingSpinner,
    HsaAccountCard,
    NotionalAccountCard,
    WidgetGridContainer,
  }
})
export default class AccountSummaryDashboard extends Vue {
  userStore = useUserStore();
  hsabAccountsStore = useHsabAccountsStore();
  communicationStore = useCommunicationStore();
  featureFlagStore = useFeatureFlagStore();
  managedExpenseStore = useManagedExpenseStore();
  partnerPortalStore = usePartnerPortalStore();

  formatCurrency = formatCurrency;
  minHeightForCards = "215px";

  @Prop({ default: false })
  closedAccounts: boolean;

  get activeHsaAccounts () {
    return this.hsabAccountsStore.hsaAccounts.filter(a => a.isActive);
  }

  created (): void {
    this.hsabAccountsStore.getHsabAccounts();
    this.managedExpenseStore.loadActionNeededPreview();
  }

  get showActionNeededWidget () {
    return this.managedExpenseStore.hasActionNeeded;
  }

  get showMfa () {
    return !this.featureFlagStore.flags.bend26540LoginPromptOrchestrator
        // when this flag is on, MFA prompt is handled via the LoginPromptOrchestator in the navbar
        && this.hsabAccountsStore.userHasAnyActiveAccount;
  }

  get showDashboardHeaderItems () {
    return !this.closedAccounts || !this.hsabAccountsStore.userHasAnyActiveAccount;
  }

  get activeNotionalAccounts () {
    return this.hsabAccountsStore.notionalAccounts.filter(a => a.isActive);
  }

  get inactiveHsaAccounts () {
    return this.hsabAccountsStore.hsaAccounts.filter(a => !a.isActive);
  }

  get inactiveNotionalAccounts () {
    return this.hsabAccountsStore.notionalAccounts.filter(a => !a.isActive);
  }

  @Watch("hsabAccountsStore.accountsFetchState", { immediate: true })
  safeToLoad (state) {
    if (state === FetchState.Loaded) {
      const dashboard = this.activeHsaAccounts.length > 0
          ? CommunicationDashboard.Combined
          : CommunicationDashboard.Notional;
      this.communicationStore.loadEmployeeCommunications({
        planTypes: this.hsabAccountsStore.planTypes,
        dashboard
      });
      if (!this.closedAccounts && !this.hsabAccountsStore.userHasAnyActiveAccount) {
        if (!this.partnerPortalStore.hasActiveAccount) {
          this.$router.push( { name: RouteNames.Home });
        } else {
          // redirect to the closed accounts page if the user does not have any active plans
          this.$router.push({name: RouteNames.InactiveAccountsSummary});
        }
      }
    }
  }

  handleActionLinkClick (v: any) {
    const r: any = this.communicationStore.communications.filter(x => x.id === v)[0];
    if (r.isActionLinkExternal) {
      openUrl(r.actionLink);
    } else {
      this.$router.push(getRoutePath(r.actionLink));
    }
    this.userStore.saveUserEvent({
      eventType: UserEventType.PartnerCommunicationWidgetClick,
      values: [
        { key: UserEventKey.PartnerCommunicationId, value: r.id },
        { key: UserEventKey.PartnerCommunicationSubject, value: r.subject },
        { key: UserEventKey.PartnerCommunicationLocation, value: "employee" }
      ]
    });
  }
}
